import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RequiredFieldsService {
  // Fields required for issue starting
  private requiredFields = new Set([
    'assetClass',
    'assetSubclass',
    'emittentCompany',
    'industries',
    'productName',
    'productNumber',
    'permittedInvestorClasses',
    // Fields required for create fund dialog
    'issuerName',
    'fundName',
    'issuerAdminEmail',
  ]);

  public isFieldRequired(controlName: string): boolean {
    return this.requiredFields.has(controlName);
  }
}
